import { render, staticRenderFns } from "./sign2.vue?vue&type=template&id=ba587188"
import script from "./sign2.vue?vue&type=script&lang=js"
export * from "./sign2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba587188')) {
      api.createRecord('ba587188', component.options)
    } else {
      api.reload('ba587188', component.options)
    }
    module.hot.accept("./sign2.vue?vue&type=template&id=ba587188", function () {
      api.rerender('ba587188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personnel/sign2.vue"
export default component.exports